import React from 'react';
import PropTypes from "prop-types";

import Banner from './Banner.js';
import Experience from "../Experience/Experience.js";
import SplitPane from "../Product/SplitPane.js";
import Contact from "../Contact/Contact.js";
import TextList from "../Product/TextList.js";

const Homepage = ({ copy }) => {
  return (
    <div>
      <Banner copy={copy.homepage} key={copy.homepage[0]} />
      <Experience image="image.png" copy={copy.experience} key={copy.experience[0]} />
      <SplitPane copy={copy.productOne} highlighted withButton key={copy.productOne[0]} />
      <TextList copy={copy.productTwo} inverted withButton key={copy.productTwo[0]} />
      <SplitPane copy={copy.productThree} highlighted={false} withButton={false} key={copy.productThree[0]} />
      <Contact copy={copy.contactPage} key={copy.contactPage[0]} />
    </div>
  );
};

Homepage.propTypes = {
  copy: PropTypes.object.isRequired
}

export default Homepage;


// WEBPACK FOOTER //
// ./src/Homepage/Homepage.js